import React from 'react';
import { DragSource } from 'react-dnd';
import { Link } from 'react-router';
import KeyHandler, { KEYDOWN, KEYUP } from 'react-key-handler';
import _ from 'lodash';
import keydown from 'react-keydown';
import { Modal, Button, Row, Col, ListGroup, ListGroupItem } from 'react-bootstrap';
import { createDragPreview } from 'react-dnd-text-dragpreview';
import $ from 'jquery'

import { OrderPin } from './OrderPin';
import { OrderId } from './OrderId';
import { DriverName } from './DriverName';
import { CashOnDelivery } from './CashOnDelivery';
import {  parseExpectedPickUpTimeOnlyTime } from '../../../businessLogic/expectedPickUpTimeParser.js';
import { formatDeliveryTime } from '../../../businessLogic/deliveryTimeFormatter.js';
import { ItemTypes } from '../../../constants/actionTypes';
import { gettext } from '../../../i18n/service.js';
import DriverListModal from '../../modals/DriverListModal';

import './orderIcons';
import './Order.scss';

const orderSource = {
  beginDrag(props) {
    return {
      selectedOrders: props.selectedOrders,
    };
  }
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
}

@DragSource(ItemTypes.ORDER, orderSource, collect)
export class Order extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      ctrlIsPressed: false,
      showModal: false,
      showAssignModal: false
    }

    _.bindAll(this, ['selectOrder', 'renderKeyBinders', 'close', 'open']);
  }

  selectOrder(e, order) {
    //this.props.router.push(`recipient/${order.id}`);
    if (this.state.ctrlIsPressed) {
      this.props.handleOrderSelectChange(order, e);
    } else {
      this.props.orderClick(order);
    }
  }

  renderKeyBinders() {
    return (
      <div>
        <KeyHandler
          keyEventName={KEYDOWN}
          keyCode={17}
          onKeyHandle={(e) => {
            if (!this.state.ctrlIsPressed)
              this.setState({ ctrlIsPressed: true })
          }} />
        <KeyHandler
          keyEventName={KEYUP}
          keyCode={17}
          onKeyHandle={(e) => {
            if (this.state.ctrlIsPressed)
              this.setState({ ctrlIsPressed: false })
          }} />
        <KeyHandler
          keyEventName={KEYDOWN}
          keyCode={91}
          onKeyHandle={(e) => {
            if (!this.state.ctrlIsPressed)
              this.setState({ ctrlIsPressed: true })
          }} />
        <KeyHandler
          keyEventName={KEYUP}
          keyCode={91}
          onKeyHandle={(e) => {
            if (this.state.ctrlIsPressed)
              this.setState({ ctrlIsPressed: false })
          }} />
        <KeyHandler
          keyEventName={KEYDOWN}
          keyCode={224}
          onKeyHandle={(e) => {
            if (!this.state.ctrlIsPressed)
              this.setState({ ctrlIsPressed: true })
          }} />
        <KeyHandler
          keyEventName={KEYUP}
          keyCode={224}
          onKeyHandle={(e) => {
            if (this.state.ctrlIsPressed)
              this.setState({ ctrlIsPressed: false })
          }} />
      </div>
    );
  }

  @keydown( 'esc' )
    onEscKeyDown() {
      this.close();
    }

  close() {
    this.setState({ showModal: false });
    this.setState({ showAssignModal: false });
  }

  open(e) {
    this.setState({ showModal: !this.state.showModal });
    const parent = document.getElementById( "sidebar-orders-expander" );
    const elem = $(parent).find(".ReactCollapse--content > div:first-child > div:first-child");
    const offset = elem.scrollTop() + $(e.nativeEvent.target).offset().top - elem.offset().top;
    if(!this.state.showModal && e.nativeEvent.clientY > parent.scrollHeight) {
      $(elem[0]).animate({
        scrollTop: offset,
      }, 800);
    }
  }

  showDetailModal(e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.renderModalForDetails(this.props.order);
    this.setState({ showModal: false });
  }

  showAssignModal(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ showModal: false });
    this.setState({ showAssignModal: true });
  }

  removeClass() {
    var element = document.getElementById("sidebar-order-new");
    element.classList.remove("moving");
  }

  render() {
    const order = this.props.order;
    const pickUpPoints = this.props.pickUpPoints;
    const recipients = this.props.recipients;
    const driver = _.find(this.props.drivers, { id: order.driverId });
    let address = '---';
    if (order.items && order.items.length > 0) {
      if (order.orderStatus === 'new') {
        const point = _.find(pickUpPoints, { id: order.items[0].pickupPointId });
        address = point && point.address?point.address:'Can not get address';
      } else {
        const point = _.find(recipients, { id: order.recipientId });
        address = point && point.deliveryPoint?point.deliveryPoint:'Can not get address';
      }
    }

    if (this.props.orderType === 'new') {
      return this.props.connectDragSource(
        <div
          className={this.props.isSelected ? 'sidebar-order selected' : 'sidebar-order new'}
          id="sidebar-order-new"
          onClick={(e) => this.selectOrder(e, order)}
          onMouseOver={() => this.removeClass()}
          draggable="true"
          onDragStart={(e) => this.props.startDraggingOrder(order)}>
          {this.renderKeyBinders()}
          <div>
            <div className="media-left">

            </div>
            <div className="media-body">
              <OrderId order={order} />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <img src='./side_cod.svg' />
              <CashOnDelivery order={order} />
              <Link onClick={(e) => {
                this.open(e);
              }}>
                <img src="./side_menu.svg" className="float-right"/>
              </Link>
              {
                this.state.showModal &&
                <ListGroup className="order-setting">
                  <ListGroupItem onClick={(e) => {
                    this.showAssignModal(e)
                  }}>{gettext('ORDER-ASSIGN-DRIVER')}</ListGroupItem>
                  <ListGroupItem onClick={(e) => {
                    this.showDetailModal(e)
			  }}>{gettext('ORDER-DETAILS-DRIVER')}</ListGroupItem>
                </ListGroup>
              }
            </div>
          </div>
          <div>
            <div className="media-left">
              <OrderPin order={order} />
            </div>
            <div className="media-body">
              <span className="delivery-point">{address}</span>
               <span>
                {
                  order.orderStatus === 'new'
                    ? parseExpectedPickUpTimeOnlyTime(order.expectedPickUpTime)
                    : formatDeliveryTime(order.expectedPickUpTime.endTime, order.deliveryTime)
                }
               </span>
              &nbsp;
              <DriverName driver={driver} />
            </div>
          </div>
          {
            this.state.showAssignModal &&
            <DriverListModal
              showModal={this.state.showAssignModal}
              close={this.close}
              drivers={this.props.drivers}
              orders={this.props.orders}
              originalOrders={this.props.originalOrders}
              vehicles={this.props.vehicles}
              recipients={this.props.recipients}
              order={this.props.order}/>
          }
          {this.state.modal}
        </div>
      )
    }
    else {
      return (
        <div
          className={this.props.isSelected ? 'sidebar-order selected' : 'sidebar-order'}
          onClick={(e) => this.selectOrder(e, order)}>
          {this.renderKeyBinders()}
          <div>
            <div className="media-left">

            </div>
            <div className="media-body">
              <OrderId order={order} />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <img src='./side_cod.svg' />
              <CashOnDelivery order={order} />
              <Link onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                this.props.renderModalForDetails(order)
              }}>
                <img src="./side_menu.svg" className="float-right"/>
              </Link>
            </div>
          </div>
          <div>
            <div className="media-left">
              <OrderPin order={order} />
            </div>
            <div className="media-body">
              <span className="delivery-point">{address}</span>
               <span>
                {
                  order.orderStatus === 'new'
                    ? parseExpectedPickUpTimeOnlyTime(order.expectedPickUpTime)
                    : formatDeliveryTime(order.expectedPickUpTime.endTime, order.deliveryTime)
                }
               </span>
              &nbsp;
              <DriverName driver={driver} />
            </div>
          </div>
          {this.state.modal}
        </div>
      )
    }
  }
}

// export default DragSource(ItemTypes.ORDER, orderSource, collect)(Order);



// WEBPACK FOOTER //
// ./src/components/sidebarOrders/order/Order.js